import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Header from "../Components/Header";
import GetTokenController from "../../Controller/GetTokenController";
import CreateFormateur from "../../Controller/CreateFormateur";

const CreateArticleView = () => {
    const [prenom, setPrenom] = useState('');
    const [role, setRole] = useState('');
    const [type, setType] = useState('');
    const [description, setDescription] = useState([]);
    const [createAttempt, setCreateAttempt] = useState(false);

    const handlecreate = (event) => {
        event.preventDefault();

        setCreateAttempt(true);

        return <CreateFormateur prenom={prenom} role={role} type={type} description={description} />;
    };

    return (
        <>
            <Header title="Creation d'article" />
            <h1 className='text-white text-center mb-5'>Connexion</h1>
            <Form className='text-black' onSubmit={handlecreate}>
                <Form.Group className="mb-3" controlId="formBasicUsername">
                    <Form.Label>Prenom</Form.Label>
                    <Form.Control
                        className='mb-5'
                        type="text"
                        placeholder="Prenom du formateur"
                        onChange={(e) => setPrenom(e.target.value)}
                        required
                    />
                </Form.Group>

                <Form.Group className="mb-5" controlId="formBasicContent">
                    <Form.Label>Role</Form.Label>
                    <Form.Control
                        as="textarea" // Change to textarea
                        rows={5} // Optional: define rows for textarea
                        placeholder="Role du formateur"
                        onChange={(e) => setRole(e.target.value)}
                        required
                    />
                </Form.Group>
                <Form.Group className="mb-5" controlId="formBasicContent">
                    <Form.Label>Type</Form.Label>
                    <Form.Control
                        as="textarea" // Change to textarea
                        rows={5} // Optional: define rows for textarea
                        placeholder="Types de formation dispensé"
                        onChange={(e) => setType(e.target.value)}
                        required
                    />
                </Form.Group>
                <Form.Group className="mb-5" controlId="formBasicContent">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                        as="textarea" // Change to textarea
                        rows={5} // Optional: define rows for textarea
                        placeholder="Description du formateur"
                        onChange={(e) => setDescription(e.target.value)}
                        required
                    />
                </Form.Group>
                <div className='text-center mt-5 mb-3'>
                    <Button className='mb-4' size="lg" variant="secondary" type="submit">
                        Créer l'article
                    </Button>
                </div>
            </Form>
            {createAttempt && (
                <CreateFormateur prenom={prenom} role={role} type={type} description={description} />
            )}
        </>
    );
};

export default CreateArticleView;